/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("scroll.lock", require("./rawicons/scroll.lock.svg.js"));
